export default "__VITE_ASSET__b2bdb390__"